import type { ReactNode } from 'react';
import { cx } from '../../../utils/cx';
import { Icon } from '../Icon/Icon';
import styles from './FormControls.module.scss';
import React from 'react';

interface FieldProps {
  /** Совпадает с id контрола — по нему же ставится фокус при ошибке. */
  htmlFor?: string;
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  counter?: { current: number; max: number };
  children: ReactNode;
}

/** Обвязка поля: подпись, счётчик, подсказка и сообщение об ошибке вместо неё. */
export function Field({ htmlFor, label, required, hint, error, counter, children }: FieldProps) {
  const near = counter ? counter.current > counter.max * 0.9 : false;
  // Группе контролов (например, радиокнопкам) htmlFor не нужен — тогда это не <label>.
  const Caption = htmlFor ? 'label' : 'span';

  return (
    <div className={styles.field}>
      <Caption className={styles.label} htmlFor={htmlFor}>
        {label} {required && <span className={styles.req}>*</span>}
        {counter && (
          <span className={cx(styles.counter, near && styles.near)}>
            {counter.current} / {counter.max}
          </span>
        )}
      </Caption>

      {children}

      {error ? (
        <p className={styles.error}>
          <Icon name="alert" size={10} strokeWidth={2.2} />
          <span>{error}</span>
        </p>
      ) : (
        hint && <p className={styles.hint}>{hint}</p>
      )}
    </div>
  );
}
